import { loadComparePopup } from '../async/loadComparePopup.js';
import { parentElements } from '../utils/parentElements';
import { logError } from '../utils/logError';
import URLQueryParams from '/js/url-query-params';

export function addComparingHandlers() {
    async function clickHandler() {
        try {
            if (this.dataset.isLoading) return;

            let productId;
            let productBox;
            let url = '';
            let isDetailPage = document.querySelectorAll('.detail-product-body').length !== 0;

            if (isDetailPage) {
                productBox = parentElements(this, (el) => el.classList.contains('product'))[0];
                productId = this.dataset.productId?.toString() || '';
                if (!productId) {
                    productId = document.querySelector('.js-add-to-comparing')?.dataset.productId.toString();
                }

                if (this.classList.contains('active')) {
                    window.location.replace('/personal/compare/');
                    return;
                }
            } else {
                productBox = parentElements(this, (el) => {
                    return el.classList.contains('catalog-product')
                        || el.classList.contains('product-tile')
                        ;
                })[0];
                productId = this.dataset.productId.toString();
            }

            if (window.customerData.comparing.indexOf(productId) === -1) {
                url = '/api/prk/compare/addProductToComparing.php';
            } else {
                url = '/api/prk/compare/deleteProductFromComparing.php';
            }

            this.dataset.isLoading = true;

            const ComparePopup = await loadComparePopup();

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLQueryParams({ 'product_id': productId }),
            });

            const data = await response.json();
            if (data.success) {
                if (data.isProductInComparingList) {
                    window.customerData.comparing.push(productId);
                    ComparePopup.show('added', productBox, data.countOfProductsInComparingList, isDetailPage);
                } else {
                    window.customerData.comparing = window.customerData.comparing.filter(currentId => currentId !== productId);
                    ComparePopup.show('deleted', productBox, data.countOfProductsInComparingList, isDetailPage);
                }

                updateCustomerComparingView();
            }
        } catch (err) {
            logError(err);
        }
        
        delete this.dataset.isLoading;
    }
    
    document
        .addEventListener('click', (e) => {
            if (e.target.classList.contains('js-add-to-comparing')) {
                clickHandler.call(e.target, e);
            }

            const target = parentElements(e.target, (el) => el.classList.contains('js-add-to-comparing'))[0];
            if (target) clickHandler.call(target, e);
        });
}
